import { Action } from "../../../domain/entities/ActionModel";
import { ArchiveState, StateStatus } from "../../../domain/entities/State";
import { ArchiveActionTypes } from "../actions/archive";

const initialState: ArchiveState = {
  searchResults: [],
  searchStatus: StateStatus.INIT,
  searchError: null,
  folderFiles: {},
  archiveFilesStatus: StateStatus.INIT,
  archiveFilesError: null,
  downloadStatus: StateStatus.INIT,
  downloadError: null,
  orderData: {},
  orderDataStatus: StateStatus.INIT,
  orderDataError: null,
};

export default (state = initialState, action: Action<any>): ArchiveState => {
  switch (action.type) {
    case ArchiveActionTypes.ARCHIVE_SEARCH_PROCESSING:
      return {
        ...state,
        searchStatus: StateStatus.LOADING,
      };
    case ArchiveActionTypes.ARCHIVE_SEARCH_COMPLETE:
      return {
        ...state,
        searchStatus: StateStatus.COMPLETE,
        searchResults: action.payload,
        searchError: null,
      };
    case ArchiveActionTypes.ARCHIVE_SEARCH_ERROR:
      return {
        ...state,
        searchStatus: StateStatus.ERROR,
        searchError: action.payload,
      };
    case ArchiveActionTypes.ARCHIVE_FILES_PROCESSING:
      return {
        ...state,
        archiveFilesStatus: StateStatus.LOADING,
      };
    case ArchiveActionTypes.ARCHIVE_FILES_COMPLETE:
      return {
        ...state,
        archiveFilesStatus: StateStatus.COMPLETE,
        folderFiles: { ...state.folderFiles, [action.payload.folderId]: action.payload.files },
        archiveFilesError: null,
      };
    case ArchiveActionTypes.ARCHIVE_FILES_ERROR:
      return {
        ...state,
        archiveFilesStatus: StateStatus.ERROR,
        archiveFilesError: action.payload,
      };
    case ArchiveActionTypes.ARCHIVE_DOWNLOAD_PROCESSING:
      return {
        ...state,
        downloadStatus: StateStatus.LOADING,
      };
    case ArchiveActionTypes.ARCHIVE_DOWNLOAD_COMPLETE:
      return {
        ...state,
        downloadStatus: StateStatus.COMPLETE,
        downloadError: null,
      };
    case ArchiveActionTypes.ARCHIVE_DOWNLOAD_ERROR:
      return {
        ...state,
        downloadStatus: StateStatus.ERROR,
        downloadError: action.payload,
      };
    case ArchiveActionTypes.ARCHIVE_ORDER_DATA_PROCESSING:
      return {
        ...state,
        orderDataStatus: StateStatus.LOADING,
      };
    case ArchiveActionTypes.ARCHIVE_ORDER_DATA_COMPLETE:
      return {
        ...state,
        orderDataStatus: StateStatus.COMPLETE,
        orderData: { ...state.orderData, [action.payload.folderId]: action.payload.data },
        orderDataError: null,
      };
    case ArchiveActionTypes.ARCHIVE_ORDER_DATA_ERROR:
      return {
        ...state,
        orderDataStatus: StateStatus.ERROR,
        orderDataError: action.payload,
      };
    case ArchiveActionTypes.ARCHIVE_CLEAR:
      return initialState;
    default:
      return state;
  }
};
